/**
 * hash
 * Helpers for window.location.hash
 */

export default {

  listen: function (callback, fireOnLoad) {
    if (!callback) { return; }
    if (fireOnLoad && this.val()) {
      callback(this.val());
    }
    window.addEventListener('hashchange', () => {
      callback(this.val());
    });
  },

  val: function () {
    var hash = window.location.hash;
    return hash.length === 0 ? false : hash.substring(1);
  }

};
